<div class="container" *ngIf="!previewing">

  <div class="header">
    <div class="title">
      <span>Atalhos</span>
    </div>
    <div>
      <button mat-stroked-button
        class="preview-button background-primary-color"
        (click)="onPreviewLink()"
      >
        Pré-visualizar
      </button>
    </div>
  </div>

  <div class="main-content">

    <div class="left-content">
      <div class="sub-title">
        Organize os atalhos
      </div>
      <div class="instructions">
        Adicione itens, arraste para reordenar e mais.
        Não se esqueça de <strong>salvar</strong> as modificações para que elas sejam refletidas no aplicativo.
      </div>
      <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div class="items-container" *ngFor="let link of links" cdkDrag>
          <app-link-item
            [link]="link"
            (onUpdateLink)="onUpdateLink(link)"
            (onDeleteLink)="onDeleteLink(link)"
          >
          </app-link-item>
        </div>  
      </div>
      <button class="button-new" (click)="onNewLink()">
        <mat-icon>add_circle</mat-icon>
        Adicionar novo atalho
      </button>
    </div>

    <div class="right-content">
      <div class="sub-title">
        Pré-visualização
      </div>
      <app-links-preview [links]="links">
      </app-links-preview>
    </div>

  </div>

  <div class="footer">
    <button mat-raised-button
      [disabled]="!hasChanges"
      class="btn-discard"
      (click)="onDiscardChanges()"
      [className]="
        hasChanges
          ? 'btn-discard mat-focus-indicator mat-raised-button mat-button-base'
          : 'btn-discard mat-focus-indicator mat-raised-button mat-button-base disabled submit-disabled'
      "
    >
      Descartar
    </button>
    <button mat-raised-button
      [disabled]="!hasChanges"
      (click)="onSave()"
      [className]="
        hasChanges
          ? 'btn-save mat-focus-indicator mat-raised-button mat-button-base'
          : 'btn-save mat-focus-indicator mat-raised-button mat-button-base disabled submit-disabled'
      "
    >
      Salvar
    </button>
  </div>
</div>

<div *ngIf="previewing">
  <div class="previewing-title">
    <button class="preview-close-button" (click)="onClosePreview()">
      <span class="material-icons">close</span>
    </button>
    <span>Pré-visualizar</span>
  </div>
  <app-links-preview [links]="links">
  </app-links-preview>
</div>
